import { del, post } from '@api/api-client';

export interface NominationResponse {
  id: string;
  participantId: string;
  editionCategoryId: string;
  voteCount: number;
  ranking: number | null;
  isWinner: boolean;
  createdAt: string;
  updatedAt: string;
}

interface BulkCreateNominationsDTO {
  editionCategoryId: string;
  participantIds: string[];
}

/** Creates multiple nominations for an edition category. */
export function bulkCreateNominations(
  data: BulkCreateNominationsDTO,
): Promise<NominationResponse[]> {
  return post<NominationResponse[]>('/nominations/bulk', data);
}

/** Deletes a nomination by ID. */
export function deleteNomination(id: string): Promise<void> {
  return del(`/nominations/${id}`);
}
